import { EyeTest, eyeTestOptions } from "./types";

const renderEyeTest = (value: EyeTest) => {
  return eyeTestOptions[value] || "Not answered";
};

export { renderEyeTest };
